var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 15,
    fill: "#828385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,8.26,15.37,3.9h1.77l1.67,2.82L20.47,3.9h1.74L19.57,8.3V11H18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.92,8.8c0,.9.48,1.31,1.27,1.31a1.17,1.17,0,0,0,1.12-.67h1.25a2.33,2.33,0,0,1-2.42,1.74A2.53,2.53,0,0,1,21.5,8.46a2.59,2.59,0,0,1,2.64-2.73c1.76,0,2.61,1.48,2.51,3.07Zm2.31-.9c-.13-.72-.44-1.1-1.13-1.1a1.12,1.12,0,0,0-1.18,1.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.59,9.36c0,.62.53.87,1.09.87s.93-.16.93-.66S30,9,29,8.77c-.82-.18-1.64-.47-1.64-1.38,0-1.32,1.14-1.66,2.25-1.66s2.17.38,2.28,1.65H30.54c0-.55-.46-.7-1-.7-.32,0-.79.06-.79.48s.8.58,1.61.77S32,8.42,32,9.38c0,1.36-1.18,1.8-2.36,1.8s-2.37-.45-2.43-1.82Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesFill);
export default __webpack_public_path__ + "static/media/YesFill.d0335dbaa88fba5887ef2dcf5ee61cfa.svg";
export { ForwardRef as ReactComponent };